import { render, staticRenderFns } from "./CommentaryPlusSettingsDialog.vue?vue&type=template&id=1ad71621&scoped=true"
import script from "./CommentaryPlusSettingsDialog.vue?vue&type=script&lang=js"
export * from "./CommentaryPlusSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentaryPlusSettingsDialog.vue?vue&type=style&index=0&id=1ad71621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad71621",
  null
  
)

export default component.exports